// extracted by mini-css-extract-plugin
export default {"number":"TabBarNav_number__2dwGq","tabbutton":"TabBarNav_tabbutton__wmhs3","tabbutton--active":"TabBarNav_tabbutton--active__wJnjy"};